// const WebSocketPlugin = {
//     install(Vue, options = {}) {
//         const socketUrl = options.url || 'ws://your-socket-server-url';
//         const reconnectInterval = options.reconnectInterval || 3000; // 重连间隔时间，单位毫秒
//         const maxReconnectAttempts = options.maxReconnectAttempts || null; // 最大重连尝试次数，null 表示无限尝试
//
//         let socket;
//         let isConnected = false;
//         let reconnectAttempts = 0;
//
//         const connect = () => {
//             socket = new WebSocket(socketUrl);
//
//             socket.onopen = () => {
//                 console.log('WebSocket连接已打开');
//                 isConnected = true;
//                 reconnectAttempts = 0;
//             };
//
//             socket.onmessage = (event) => {
//                 console.log('收到消息:', event.data);
//                 Vue.prototype.$socket.$emit('message', event.data);
//             };
//
//             socket.onclose = (event) => {
//                 console.log('WebSocket连接已关闭', event);
//                 isConnected = false;
//
//                 if (
//                     maxReconnectAttempts === null ||
//                     reconnectAttempts < maxReconnectAttempts
//                 ) {
//                     setTimeout(() => {
//                         console.log('尝试重连...');
//                         reconnectAttempts++;
//                         connect();
//                     }, reconnectInterval);
//                 }
//             };
//
//             socket.onerror = (error) => {
//                 console.error('WebSocket发生错误', error);
//                 Vue.prototype.$socket.$emit('error', error);
//             };
//         };
//
//         Vue.prototype.$socket = {
//             send(message) {
//                 if (socket && socket.readyState === WebSocket.OPEN) {
//                     socket.send(message);
//                 }
//             },
//             isConnected() {
//                 return isConnected;
//             },
//         };
//
//         connect();
//     },
// };
//
// export default WebSocketPlugin;
export default class WebSocketService {
    constructor(url) {
        this.url = url;
        this.socket = null;
        this.isAlive = false; // 用于判断心跳是否正常
        this.reconnectAttempts = 0; // 重连尝试次数
        this.MAX_RECONNECT_ATTEMPTS = 10; // 最大重连次数
        this.HEARTBEAT_INTERVAL = 30000; // 心跳间隔时间 (30秒)
        this.heartbeatTimer = null;
        this.reconnectTimer = null;
        this.listeners = {};
        this.isOpen = false;//判断是否连接中


        this.connect();
    }

    connect() {
        this.socket = new WebSocket(this.url);

        this.socket.onopen = () => {
            console.log('WebSocket connection established');
            this.reconnectAttempts = 0; // 成功连接后重置重试次数
            this.isOpen = true;
            this.emit('open');
            this.startHeartbeat(); // 开始心跳检测
        };

        this.socket.onmessage = (event) => {
            // 处理接收到的消息
            console.log('Received message:', event)
            let data;
            try {
                data = JSON.parse(event.data);
            } catch (e) {
                data = event.data;
            }
            if (event.data.includes('msgId')) {
                this.receivePong();
            }
            this.emit('message', data);
        };

        this.socket.onclose = () => {
            console.log('WebSocket connection closed');
            this.isOpen = false;
            this.emit('close');
            this.stopHeartbeat();
            this.attemptReconnect();
        };

        this.socket.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.emit('error');
        };
    }

    startHeartbeat() {
        console.log('startHeartbeat-开始心跳检测：每隔30s检测一次',this.heartbeatTimer)
        if(this.heartbeatTimer){
            clearInterval(this.heartbeatTimer);
        }
        this.heartbeatTimer = setInterval(() => {
            console.log('Heartbeat-进入心跳检测：判断参数，相等',this.socket.readyState,WebSocket.OPEN)
            if (this.socket.readyState === WebSocket.OPEN) {
                this.isAlive = false;
                this.sendPing();
            }else{
                this.attemptReconnect()
            }
        }, this.HEARTBEAT_INTERVAL);
    }

    stopHeartbeat() {
        console.log('stopHeartbeat')
        if (this.heartbeatTimer) {
            clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = null;
        }
    }

    sendPing() {
        console.log('sendPing')
        this.socket.send(JSON.stringify({type: 'ping'}))
            // ,
            // success: (res) => {
            //     console.log('sendPing-发送ping成功',res)
            // },
            // fail:(error)=>{
            //     console.log('sendPing-发送ping失败',error)
            //     this.attemptReconnect()//尝试重连
            // }
        // });
        // setTimeout(() => {
        //     if (!this.isAlive) {
        //         console.warn('WebSocket heartbeat failed, attempting to reconnect...');
        //         this.socket.close();
        //     }
        // }, this.HEARTBEAT_INTERVAL / 2); // 如果没有pong响应，则关闭并重连
    }

    receivePong() {
        console.log('receivePong')
        this.isAlive = true;
    }

    attemptReconnect() {
        console.log('attemptReconnect')
        if (this.reconnectAttempts < this.MAX_RECONNECT_ATTEMPTS) {
            this.reconnectAttempts++;
            console.log(`Attempting to reconnect (${this.reconnectAttempts})...`);
            this.reconnectTimer = setTimeout(() => {
                this.connect();
            }, 1000 * this.reconnectAttempts); // 指数退避算法
        } else {
            console.error('Max reconnect attempts reached');
            this.Error()
        }
    }

    sendMessage(message) {
        console.log('sendMessage')
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(message));
        }
    }

    close() {//手动关闭
        console.log('close')
        this.stopHeartbeat();
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    }
    Error() {
        console.log('error')
        this.stopHeartbeat();
        this.socket.onerror()
    }

    // 事件监听
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    }

    // 移除监听
    off(event, callback) {
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
        }
    }

    // 触发事件
    emit(event, ...args) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => callback(...args));
        }
    }

    // 发送队列中的消息
    flushMessageQueue() {
        while (this.messageQueue.length > 0) {
            const message = this.messageQueue.shift();
            this.send(message);
        }
    }

    // 调试日志
    log(...args) {
        if (this.options.debug) {
            console.log('[PartialWebSocket]', ...args);
        }
    }
}
// export const useWebSocket = (url)=> {
//     const ws = new WebSocketService(url);
//
//     let message = null;
//     let isConnected = false;
//
//     const onMessage = (callback) => {
//         ws.socket.onmessage = (event) => {
//             message = event.data;
//             console.log('on Message received:', event.data)
//             callback(event.data);
//             if (event.data.includes('pong')) {
//                 ws.receivePong();
//             }
//         };
//     };
//
//     const onClose = (callback) => {
//         ws.socket.onclose = () => {
//             isConnected = false;
//             callback();
//         };
//     };
//
//     const onOpen = (callback) => {
//         ws.socket.onopen = () => {
//             isConnected = true;
//             callback();
//         };
//     };
//
//     // onMounted(() => {
//     //     onOpen(() => console.log('Connected'));
//     //     onClose(() => console.log('Disconnected'));
//     //     onMessage((data) => console.log('Received:', data));
//     // });
//     //
//     // onUnmounted(() => {
//     //     ws.close();
//     // });
//
//     return { isConnected, sendMessage: ws.sendMessage.bind(ws), message,onOpen,onClose,onMessage };
// }